import styled from "styled-components";

export const CopyContainer = styled.span`
  display: flex;
`;
